import { render, staticRenderFns } from "./updateWuliao.vue?vue&type=template&id=9810c11a&scoped=true&"
import script from "./updateWuliao.vue?vue&type=script&lang=js&"
export * from "./updateWuliao.vue?vue&type=script&lang=js&"
import style0 from "./updateWuliao.vue?vue&type=style&index=0&id=9810c11a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9810c11a",
  null
  
)

export default component.exports